import React, { FC, useMemo } from 'react'
import { SelectedPacket } from './enrollFormTypes'
import { Button } from 'components/button/Button'
import './selectedPackagesTray.scss'

type SelectedPackagesTrayProps = {
    selectedPackets: SelectedPacket[]
    onContinue: () => void
    continueLabel: string
}

/** One thumbnail per package_id (multi-qty still shows a single thumb). */
const uniquePackageThumbs = (packets: SelectedPacket[]): SelectedPacket[] => {
    const seen = new Set<string>()
    const thumbs: SelectedPacket[] = []
    packets.forEach((packet) => {
        const key = packet.package_id || packet.uuid || ''
        if (!key || seen.has(key)) {
            return
        }
        seen.add(key)
        thumbs.push(packet)
    })
    return thumbs
}

export const SelectedPackagesTray: FC<SelectedPackagesTrayProps> = ({
    selectedPackets,
    onContinue,
    continueLabel
}) => {
    const thumbs = useMemo(
        () => uniquePackageThumbs(selectedPackets),
        [selectedPackets]
    )

    if (selectedPackets.length === 0) {
        return null
    }

    return (
        <div
            className="selected-packages-tray"
            data-testid="selected-packages-tray"
        >
            <div
                className="selected-packages-tray__thumbs"
                data-testid="selected-packages-tray-thumbs"
            >
                {thumbs.map((packet) => (
                    <div
                        key={packet.package_id || packet.uuid}
                        className="selected-packages-tray__thumb"
                    >
                        {packet.image_url ? (
                            <img
                                src={packet.image_url}
                                alt={packet.name || ''}
                                className="selected-packages-tray__thumb-image"
                            />
                        ) : (
                            <span className="selected-packages-tray__thumb-fallback">
                                {(packet.name || '?').charAt(0)}
                            </span>
                        )}
                    </div>
                ))}
            </div>
            <Button
                style="primary"
                className="selected-packages-tray__pay"
                onClick={onContinue}
                data-testid="selected-packages-tray-pay"
            >
                {continueLabel}
            </Button>
        </div>
    )
}
